/**
 * Configurações de Ambiente
 * Centraliza todas as variáveis de ambiente e configurações da aplicação
 * Seguindo Single Responsibility Principle (SOLID)
 */

interface EnvironmentConfig {
  apiBaseUrl: string;
  wsUrl: string;
  apiTimeout: number;
  refreshInterval: number;
  isDevelopment: boolean;
  isProduction: boolean;
}

/**
 * Obter configurações do ambiente
 */
const getEnvironmentConfig = (): EnvironmentConfig => {
  // Create React App usa process.env
  const isProduction = process.env.NODE_ENV === 'production';
  
  const apiBaseUrl = isProduction
    ? process.env.REACT_APP_API_BASE_URL || 'http://68.183.154.151:8090'
    : process.env.REACT_APP_API_BASE_URL || 'http://localhost:8090';

  const wsUrl = isProduction
    ? process.env.REACT_APP_WS_URL || 'ws://68.183.154.151:8090'
    : process.env.REACT_APP_WS_URL || 'ws://localhost:8090';

  const apiTimeout =
    Number(process.env.REACT_APP_API_TIMEOUT) ||
    30000;

  const refreshInterval =
    Number(process.env.REACT_APP_REFRESH_INTERVAL) ||
    30000;

  const nodeEnv = process.env.NODE_ENV || 'development';

  return {
    apiBaseUrl,
    wsUrl,
    apiTimeout,
    refreshInterval,
    isDevelopment: nodeEnv === 'development',
    isProduction: nodeEnv === 'production',
  };
};

/**
 * Configuração global da aplicação
 * Exportada como singleton para garantir consistência
 */
export const environment = getEnvironmentConfig();

/**
 * Helper para construir URLs da API
 */
export const buildApiUrl = (path: string): string => {
  const baseUrl = environment.apiBaseUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Helper para construir URLs do WebSocket
 */
export const buildWsUrl = (path: string): string => {
  const baseUrl = environment.wsUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Validação de configuração
 * Útil para debug e troubleshooting
 */
export const validateEnvironment = (): void => {
  console.group('🔧 Configuração do Ambiente');
  console.log('API Base URL:', environment.apiBaseUrl);
  console.log('WebSocket URL:', environment.wsUrl);
  console.log('API Timeout:', environment.apiTimeout, 'ms');
  console.log('Refresh Interval:', environment.refreshInterval, 'ms');
  console.log('Ambiente:', environment.isDevelopment ? 'Development' : 'Production');
  console.groupEnd();
};
